import { CreateMediaInputApiModel } from "@app/store/http/models/input";
import { CampaignButtonInputApiModel } from "./campaign-button-input.api-model";

export interface UpdateCampaignInputApiModel {
    title: string;
    person: string;
    description: string;
    story_prompt: string;
    start_date: Date;
    end_date: Date;
    buttons: CampaignButtonInputApiModel[];
    header_image?: CreateMediaInputApiModel;
    avatar_image?: CreateMediaInputApiModel;
    notify_employees?: boolean;
    is_draft?: boolean;
    show_story_prompt?: any;
    show_submit_story_btn?: any;
    enable_overlay?: boolean;
    interview_style?:boolean;
    request_story_label?:any;
    submit_story_label?:any;
    id_campaign_consent?:any;
    starting_step_id?: number | null;
}